<template>
  <Icon
    v-if="isIconify"
    :name="name"
    class="shrink-0"
    aria-hidden="true"
    :customize="customizeIcon"
    mode="svg"
  />
  <component v-else :is="icon" class="shrink-0" role="presentation" />
</template>

<script setup lang="ts">
  // stroke prop can only used for lucide icons
  const props = withDefaults(
    defineProps<{
      name: string
      stroke?: string
    }>(),
    {
      stroke: '2'
    }
  )

  const isIconify = computed(() => props.name.includes(':'))

  const customizeIcon = (svg: string) =>
    svg.replace(/stroke-width="[^"]*"/g, `stroke-width="${props.stroke}"`)

  const icon = computed(() => {
    if (isIconify.value) return null

    return defineAsyncComponent(() => import(`../../assets/icons/${props.name}.svg?component`))
  })
</script>
